import React, { useState } from 'react';
import './App.css';
import StrategicLifeAreaRater from './components/raters.jsx';
import SLUPlot from './components/sluplot.jsx';


const createInitialSlusState = (strategicLifeAreas) => {
  let state = {};
  Object.values(strategicLifeAreas).flat().forEach((slu) => {
    state[slu] = { importance: 5, satisfaction: 5 };
  });
  return state;
};


// Main component that encompasses all the strategic life areas
const StrategicLifeUnitRaterApp = () => {
  const strategicLifeAreas = {
    'Relationships': ['Significant other', 'Family', 'Friendship'],
    'Body, Mind, and Spirituality': ['Physical health/sports', 'Mental health/mindfulness', 'Spirituality/faith'],
    'Community and Society': ['Community/citizenship', 'Societal engagement'],
    'Job, Learning, and Finances': ['Job/career', 'Education/learning', 'Finances'],
    'Interests and Entertainment': ['Hobbies/interests', 'Online entertainment', 'Offline entertainment'],
    'Personal Care': ['Physiological needs', 'Activities of daily living']
  };

  // Define a key for localStorage
  const localStorageKey = 'sluValues';

  // Function to load SLUs from localStorage or return initial state
  const loadSlusFromLocalStorage = () => {
    const savedSlus = localStorage.getItem(localStorageKey);
    if (savedSlus) {
      return JSON.parse(savedSlus);
    }
    // If nothing in localStorage, return initial state with all values set to 5 (or another default)
    return createInitialSlusState(strategicLifeAreas);
  };

  const [sluValues, setSluValues] = useState(loadSlusFromLocalStorage);

  // Handler to update SLU data
  const handleSLUChange = (unit, newImportance, newSatisfaction) => {
    setSluValues(prevSluValues => {
      const updatedValues = {
        ...prevSluValues,
        [unit]: { importance: parseFloat(newImportance), satisfaction: parseFloat(newSatisfaction) }
      };
      // Save the updated values to localStorage
      localStorage.setItem(localStorageKey, JSON.stringify(updatedValues));
      return updatedValues;
    });
  };

  // Prepare data for the SLUPlot component
  const slusForPlot = Object.keys(sluValues).map(key => ({
    name: key,
    ...sluValues[key]
  }));

  return (
    <div className="strategic-life-unit-rater-app">
      <div className="strategic-life-area-raters">
        {Object.entries(strategicLifeAreas).map(([area, units]) => (
          <StrategicLifeAreaRater 
            key={area} 
            area={area} 
            units={units} 
            onSLUChange={handleSLUChange}
            sluValues={sluValues}
          />
        ))}
      </div>
      <div className="slu-plot-container">
        <SLUPlot slus={slusForPlot} onSLUMoved={handleSLUChange} />
      </div>
    </div>
  );

};

export default StrategicLifeUnitRaterApp;